<template>
  <div class="btn-wrapper flex-center" :class="[inPopup ? 'popup' : 'page']">
    <template v-for="data in configData">
      <Btn
        v-bind="data"
        :key="data.key"
        :loading="loading"
        :remainingShots="remainingShots"
        :upperLimitCount="upperLimitCount"
        @clickHandler="clickHandler"
      />
    </template>
  </div>
</template>

<script>
  import Btn from './Btn'
  export default {
    name: 'btn-group',
    components: {
      Btn,
    },
    props: {
      page: String,
      isOver: {
        type: Boolean,
        default: true,
      },
      isLogin: {
        type: Boolean,
        default: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      inPopup: {
        type: Boolean,
        default: false,
      },
      remainingShots: [String, Number],
      upperLimitCount: [String, Number],
      extraInfo: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      configData() {
        const {
          oneTimesBtnMainColor, // 登录/抽奖/下单引导按钮主背景色
          oneTimesBtnShadeColor, // 登录/抽奖/下单引导按钮阴影色
          tenTimesBtnMainColor, // 十抽按钮主背景色
          tenTimesBtnShadeColor, // 十抽按钮阴影色
          grayBtnMainColor, // 置灰按钮主背景色
          grayBtnShadeColor, // 置灰按钮阴影色
        } = this.extraInfo || {}

        const oneTimeBtnColor = {
          main:
            oneTimesBtnMainColor ||
            'linear-gradient(180deg, #00e477 0%, #009c48 100%)',
          shadow: oneTimesBtnShadeColor || 'rgba(0, 109, 63, 1)',
        }
        const tenTimesBtnColor = {
          main:
            tenTimesBtnMainColor ||
            'linear-gradient(180deg, #FF8587 0%, #FF4100 100%)',
          shadow: tenTimesBtnShadeColor || '#C52800',
        }
        const grayBtnColor = {
          main:
            grayBtnMainColor ||
            'linear-gradient(180deg, #BFBFBF 0%, #9F9F9F 100%)',
          shadow: grayBtnShadeColor || '#888888',
        }
        if (this.isOver) {
          // 活动已结束
          return [
            {
              key: 'activityIsOver',
              type: 'time',
              text: this.$t('luckyDraw.activity_end'),
              btnColor: grayBtnColor,
            },
          ]
        } else if (!this.isOver && !this.isLogin) {
          // 登陆查看抽奖券
          return [
            {
              key: 'toLogin',
              type: 'login',
              text: this.$t('luckyDraw.login_tips'),
              btnColor: oneTimeBtnColor,
            },
          ]
        } else if (
          !this.isOver &&
          this.isLogin &&
          this.remainingShots !== '' // 务必排除初始值
        ) {
          if (this.remainingShots * 1 === 0) {
            // 下单获抽奖券
            return [
              {
                key: 'toBuyShots',
                type: 'buyShots',
                text: this.$t('luckyDraw.created_order'),
                btnColor: oneTimeBtnColor,
              },
            ]
          } else {
            // 一抽与十连抽按钮
            let oneBtnColor =
              this.remainingShots >= 1 &&
              this.remainingShots <= this.upperLimitCount
                ? oneTimeBtnColor
                : grayBtnColor
            let tenBtnColor =
              this.remainingShots >= 10 &&
              this.remainingShots <= this.upperLimitCount // 超过抽奖次数限制或者不够抽奖次数时
                ? tenTimesBtnColor
                : grayBtnColor
            return [
              {
                key: 'oneDraw',
                type: 'raffle',
                text: this.$t('luckyDraw.rules_count.once'),
                count: 1,
                class: ['has-right-margin'],
                btnColor: oneBtnColor,
              },
              {
                key: 'tenDraws',
                type: 'raffle',
                text: this.$t('luckyDraw.rules_count.ten'),
                count: 10,
                btnColor: tenBtnColor,
              },
            ]
          }
        } else {
          return [
            {
              key: 'empty',
              type: 'none',
            },
          ]
        }
      },
    },
    methods: {
      clickHandler(data) {
        this.$emit('clickHandler', data)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .btn-wrapper {
    width: 100%;
  }
</style>
